import * as React from 'react'
import { SVGProps } from 'react'
const SvgSendEmail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.629.893a.85.85 0 0 1 .175.91L9.14 13.267a.85.85 0 0 1-1.387.283L6.74 12.542l-4.436.273a.85.85 0 0 1-.654-1.45L3.596 9.42.56 6.431a.85.85 0 0 1 .304-1.404L12.725.685a.85.85 0 0 1 .904.208ZM4.798 8.217l3.846-3.846a.85.85 0 0 1 1.203 1.202L4.439 10.98l1.236-.076a.85.85 0 0 1 1.425-.4l.945.94 3.46-8.502-8.794 3.22 2.087 2.055Z"
      fill="#00A965"
    />
  </svg>
)
export default SvgSendEmail
